// extracted by css-extract-rspack-plugin
export default {"participantAvatar":"ParticipantsList-module__participantAvatar__SrzgaHu","participantLimitNotice":"ParticipantsList-module__participantLimitNotice__h_iO98V"};